import { Run, RunState } from "types/generated";

// Check if the user can review the run based on the run
export const isRunReviewable = (run?: Run | null): boolean =>
  !!run &&
  run.needsApproval &&
  (run.state === RunState.Unconfirmed ||
    run.state === RunState.Queued ||
    run.state === RunState.PendingReview);
